import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import AccountingEntriesGroup from "../../models/accounting-entries-group";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface AccountingEntriesGroupDeleteModalProps {
  show: boolean;
  accountingEntriesGroup?: AccountingEntriesGroup;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingEntriesGroupDeleteModal: React.FC<
  AccountingEntriesGroupDeleteModalProps
> = ({ show, accountingEntriesGroup, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = accountingEntriesGroup
    ? `Está seguro de que quiere eliminar el asiento contable N°: ${accountingEntriesGroup.id} `
    : "";

  const onDeleteClick = async () => {
    if (accountingEntriesGroup !== undefined) {
      setSubmitting(true);
      const accountingentriesgroupStatus =
        await deleteItem<AccountingEntriesGroup>(
          `/accounting_entries_groups/${accountingEntriesGroup.id}/`,
          accountingEntriesGroup
        );

      if (accountingentriesgroupStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (accountingentriesgroupStatus.detail !== undefined) {
          message = accountingentriesgroupStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
              <h3 className="text-danger">Precaución</h3>
              <h5>No se recomienda borrar asientos contables.</h5>
              <br />
              <h5>Se perderán los datos y no se podrán recuperar.</h5>
              <br />
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AccountingEntriesGroupDeleteModal;
